exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://unpkg.com/bootstrap@3.3.7/dist/css/bootstrap.min.css);", ""]);
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!@angular/material/prebuilt-themes/indigo-pink.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/~/css-loader?{"sourceMap":false,"importLoaders":1}!D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/~/postcss-loader?{"ident":"postcss"}!D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/~/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = 3